import { BLOCKED_PICKUP_DATES } from "../blockedDates";

const CHICAGO_TZ = "America/Chicago";

function chicagoTodayISO(now) {
  return new Intl.DateTimeFormat("en-CA", { timeZone: CHICAGO_TZ }).format(now);
}

function chicagoHour(now) {
  const parts = new Intl.DateTimeFormat("en-US", { timeZone: CHICAGO_TZ, hour12: false, hour: "numeric" }).formatToParts(now);
  return parseInt(parts.find((p) => p.type === "hour").value, 10) % 24;
}

// Calendar-date-only Date (UTC midnight) — safe to run getUTCDay()/add days on
// without ever mixing in a timezone offset.
function dateOnlyFromISO(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d));
}

function addDays(dateOnly, days) {
  return new Date(Date.UTC(dateOnly.getUTCFullYear(), dateOnly.getUTCMonth(), dateOnly.getUTCDate() + days));
}

function toISO(dateOnly) {
  return dateOnly.toISOString().slice(0, 10);
}

// Mirrors Cron 1's actual behavior (api/_lib/time.js's isChicagoLocalTime +
// upcomingTuesdayUTC, and the blocked-date skip in subscription-crons.js):
// it runs every Tuesday 2pm Central and always creates a cycle for 7 days
// after itself — skipping a week entirely (trying again 7 days later) if
// that date is blocked. This predicts, from "now", what a brand-new
// signup's first cycle's week_of will actually be.
export function predictFirstPickupDate(now = new Date()) {
  const today = dateOnlyFromISO(chicagoTodayISO(now));
  const weekday = today.getUTCDay(); // 0=Sun..6=Sat — safe since `today` has no time component
  const hour = chicagoHour(now);

  const daysUntilCronRun = weekday < 2 || (weekday === 2 && hour < 14) ? 2 - weekday : 9 - weekday;
  let cronRunDate = addDays(today, daysUntilCronRun);
  let firstPickup = addDays(cronRunDate, 7);

  while (BLOCKED_PICKUP_DATES.includes(toISO(firstPickup))) {
    cronRunDate = addDays(cronRunDate, 7);
    firstPickup = addDays(cronRunDate, 7);
  }

  return firstPickup;
}

export function formatPickupDate(date) {
  return date.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", timeZone: "UTC" });
}
